function shareSocial() {
    const socialShares = document.querySelectorAll('[data-social-share]');

    const centerNewWindow = (url, w, h) => {
        const dualScreenLeft =
            typeof window.screenLeft !== 'undefined' ? window.screenLeft : screen.left;
        const dualScreenTop =
            typeof window.screenTop !== 'undefined' ? window.screenTop : screen.top;
        const width = window.innerWidth
            ? window.innerWidth
            : document.documentElement.clientWidth
            ? document.documentElement.clientWidth
            : screen.width;
        const height = window.innerHeight
            ? window.innerHeight
            : document.documentElement.clientHeight
            ? document.documentElement.clientHeight
            : screen.height;
        const left = width / 2 - w / 2 + dualScreenLeft;
        const top = height / 2 - h / 2 + dualScreenTop;
        const windowSize = `resizable=0,scrollbars=yes,width= ${w},height=${h},top=${top},left=${left}`;
        const newWindow = window.open(url, 'xx', windowSize);
        if (window.focus) newWindow.focus();
    };

    const shareHandler = (social, width, height) => {
        socialShares.forEach(socialShare => {
            let target = socialShare.querySelector(`[data-social-share=${social}]`);
            if (target) {
                target.addEventListener('click', e => {
                    e.preventDefault();
                    centerNewWindow(e.currentTarget.href, width, height);
                });
            }
        });
    };

    const init = () => {
        if (socialShares.length > 0) {
            shareHandler('facebook', '550', '330');
            shareHandler('twitter', '550', '420');
            shareHandler('linkedin', '550', '507');
        }
    };

    return {
        init,
    };
}

export default shareSocial;
